import { useTranslation } from 'next-i18next'
import React from 'react'

import { Button, BUTTON_TYPES, Image } from '@src/quince-components/src'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { getLinkPath } from '@src/quince-site-integrated/src/utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { Banner, SectionType, TextSection } from '../../contact-us.types'

import styles from './orders-return.module.scss'

interface Props {
  sections: SectionType[]
  title?: TextSection
  bannerData?: Banner
}

const OrdersAndReturnsSection = ({ sections = [], bannerData }: Props) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.ordAndReturnWrapper}>
      <Image
        title=""
        className={styles.ordAndReturnWrapper__image}
        url={bannerData?.image.file.url ?? ''}
        alt={t('cover_image')}
      />
      <div className={styles.ordAndReturn}>
        <h1 className={styles.ordersHeader}>{t('get_support')}</h1>

        <div className={styles.sections}>
          {sections.map((svg, idx) => (
            <Button
              className={styles.card}
              key={idx}
              type={BUTTON_TYPES.SECONDARY_LINK}
              round={false}
              onClick={() => {
                trackEvent(TELEMETRY_EVENT_NAMES.SUPPORT_SECTION_CLICKED, {
                  section_type: svg.textLink?.text,
                })
                if (isBrowser()) {
                  window.Gladly.navigate()
                }
              }}
              href={getLinkPath(svg.textLink) as string}
            >
              <img
                className={styles.card__icon}
                alt={t('support_section_icon', { section: svg.textLink?.text })}
                src={svg.svgDesktop?.file.url}
              ></img>
              <span className={styles.card__text}>{svg.textLink?.text}</span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OrdersAndReturnsSection
